import React from "react";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { whatYouGet } from "../../mock";
import Reveal from "../Reveal";

export default function WhatYouGet() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl text-ink">{whatYouGet.title}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{whatYouGet.subtitle}</p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whatYouGet.features.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <Reveal key={f.title} delay={i * 60}>
                <div className="group h-full rounded-2xl border border-gold/20 bg-white p-7 hover:border-gold hover:shadow-xl transition-all duration-300">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-ink text-gold group-hover:bg-gold group-hover:text-ink transition-colors">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-5 font-display text-lg text-ink">{f.title}</h3>
                  <p className="mt-2 text-[15px] text-muted-foreground leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <div className="h-full rounded-2xl bg-ink p-7">
              <h3 className="font-display text-xl text-white">{whatYouGet.trial.title}</h3>
              <ul className="mt-4 space-y-3">
                {whatYouGet.trial.items.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-white/80">
                    <span className="grid place-items-center h-5 w-5 rounded-full bg-gold text-ink shrink-0 mt-0.5">
                      <Check size={13} />
                    </span>
                    <span className="text-[15px]">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="h-full rounded-2xl border border-gold/25 bg-gold-soft/40 p-7">
              <h3 className="font-display text-xl text-ink">{whatYouGet.specs.title}</h3>
              <dl className="mt-4 divide-y divide-gold/15">
                {whatYouGet.specs.items.map((s) => (
                  <div key={s.label} className="flex items-center justify-between py-2.5">
                    <dt className="text-[15px] text-muted-foreground">{s.label}</dt>
                    <dd className="text-[15px] font-semibold text-ink">{s.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
